module.exports = __webpack_public_path__ + "img/11.8b74ebe9.png";